import { knuthShuffle } from '@utils/common';

function orderInputs(inputs, entries) {
  // We should only ever shuffle inputs that aren't fixed and the user hasn't
  // already interacted with in some form
  const indicesToIgnore = new Set(inputs.map((it, index) => it.options.fixed || entries?.length && entries.some(entry => entry.nodeId === it.id) ? index : undefined).filter(it => typeof it === "number"));
  if (indicesToIgnore.size === inputs.length) {
    const orderedEntries = entries?.slice(0)?.sort((a, b) => a.index - b.index) ?? [];
    const orderedInputs = [];

    //
    // STEP: push all ordered entries (and any fixed inputs in between, if any)
    // into our ordered inputs.
    //
    for (const entry of orderedEntries) {
      while (orderedInputs.length < entry.index) {
        const fixedInput = inputs[orderedInputs.length];
        if (!fixedInput) {
          break;
        }
        orderedInputs.push(fixedInput);
      }
      const relatedInput = inputs.find(input => entry.nodeId === input.id);
      if (relatedInput) {
        orderedInputs.push(relatedInput);
      }
    }

    //
    // STEP: Push remaining fixed inputs into our final list
    //
    for (let i = orderedInputs.length; i < inputs.length; i++) {
      const input = inputs[i];
      if (!input) {
        continue;
      }
      orderedInputs.push(input);
    }
    return orderedInputs;
  }
  return knuthShuffle(inputs.slice(0), indicesToIgnore);
}

export { orderInputs };
//# sourceMappingURL=util.order-inputs.js.map
